import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './locales/de.json';
import en from './locales/en.json';
import landingDe from './locales/landing/de.json';
import landingEn from './locales/landing/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de, landing: landingDe },
      en: { translation: en, landing: landingEn },
    },
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    ns: ['translation', 'landing'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// Sync HTML lang attribute with i18n language
const updateHtmlLang = (lng) => {
  document.documentElement.lang = lng;
};

// Set initial lang and listen for changes
updateHtmlLang(i18n.language);
i18n.on('languageChanged', updateHtmlLang);

export default i18n;
